import React, { useEffect, useState } from 'react';
import Modal from '../../../../shared/modal';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { tryToFetchPurchaseMismatch } from '../../../../store/brokers/partner/purchases/PurchasesSlice';
import Button from '../../../../shared/button';


interface IMismatchDetailsModal {
    openModal: boolean;
    purchaseId: string;
    handleCloseModal: () => void;
}

const MismatchDetailsModal = ({
    openModal,
    purchaseId,
    handleCloseModal,
}: IMismatchDetailsModal) => {
    const dispatch = useAppDispatch();
    const [purchaseDetails, setPurchaseDetails] = useState<any>();
    const state = useAppSelector((state) => state?.purchases);

    useEffect(() => {
        setPurchaseDetails(state?.purchaseMismatch)
    }, [state?.purchaseMismatch])

    useEffect(() => {
        if (purchaseId) {
            dispatch(tryToFetchPurchaseMismatch(purchaseId || ''))
        } else {
            setPurchaseDetails(undefined)
        }
    }, [purchaseId, openModal])

    const onCloseModal = () => {
        handleCloseModal();
        setPurchaseDetails(undefined)
    }

    return (
        <Modal
            open={openModal}
            showInRight
            title={'Mismatch Details'}
            onClose={() => onCloseModal()}
        >
            <div className={'p-2 min-w-[500px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Mismatch Details</p>
                </div>
                <div className='p-3 !rounded bg-[#e4ede657]'>
                    <p className='mb-5 font-bold'>Here are the details of the mismatch between order details and invoice from supplier.</p>
                    {purchaseDetails?.analyzedData?.purchaseTotal && <p className='my-2'>Purchase Total: {Number(purchaseDetails?.analyzedData?.purchaseTotal || 0).toFixed(2)}</p>}
                    {purchaseDetails?.analyzedData?.invoiceTotal && <p className='my-2'>Invoice Total: {Number(purchaseDetails?.analyzedData?.invoiceTotal || 0).toFixed(2)}</p>}
                    {purchaseDetails?.analyzedData?.discrepancy && <p className='my-2'>Discrepancy: {Number(purchaseDetails?.analyzedData?.discrepancy || 0).toFixed(2)}</p>}
                </div>
                <div className='my-10'>
                    <Button
                        label={'Close'}
                        className='btn-primary !shadow-none min-w-[120px]'
                        onClickButton={onCloseModal}
                    />
                </div>
            </div>
        </Modal>
    )
}
export default MismatchDetailsModal;